import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import ProductServices from "../../../services/ProductServices";
import UpdateInventory from "./UpdateInventory";
import * as XLSX from "xlsx";
import Pagination from "../Pagenation/Pagenation";
import { Button } from "react-bootstrap";
import Loader from "../Loader/loader";


const InventoryCriticalList = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  // Retrieve user and stores from localStorage
  const user = JSON.parse(localStorage.getItem('userDetails'));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || '';

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sort, setsort] = useState(10); // Number of items per page
  const [activePag, setActivePag] = useState(0);
  const [selectedItem, setSelectedItem] = useState({})
  const [isModelOpen, setIsModelOpen] = useState()
  const [run, setRun] = useState(0)

  // Display row options
  const options = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];



  // Fetch data from API and filter based on selectedStore
  useEffect(() => {
    if (selectedStore) {
      setLoading(true);
      ProductServices.getInventory(selectedStore)
        .then((response) => {
          const allData = response?.data?.data || [];
          const storeFilteredData = allData.filter(
            (item) => item?.store?._id === selectedStore && item?.critical === true
          );
          setData(storeFilteredData);
          setLoading(false);
        })
        .catch(() => {
          alert("There is some problem in fetching data!");
          setLoading(false);
        });
    }
  }, [selectedStore, run]);


  // Handle search
  useEffect(() => {
    if (searchTerm) {
      const filtered = data.filter((item) =>
        item?.masterItem?.partNo?.toString()?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.masterItem?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.masterItem?.category?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchTerm, data]);

  // Pagination setup
  useEffect(() => {
    setActivePag(0);
  }, [filteredData, sort]);

  const pagination = Math.ceil(filteredData.length / sort);

  const currentData = filteredData.slice(
    activePag * sort,
    (activePag + 1) * sort
  );

  const onClick = (page) => {
    setActivePag(page);
  };

  const handleSelectChange = (selectedOption) => {
    setsort(selectedOption.value);
    setActivePag(0);
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    console.log(selectedStore)
    setActivePag(0); // Reset pagination when store changes
  };

  const Persentage = (user) => {

    const auth = user?.qtyAuth || 0;  // qtyAuth
    const totalRecive = user?.totalRecive || 0;    // totalRecivequantity
    const transfer = user?.transfer || 0;  // transfer

    if (auth === 0) {
      return 0; // Prevent division by zero
    }

    const finaloutput = ((totalRecive - transfer) / auth) * 100; // Correct percentage calculation
    const roundedPercentage = finaloutput.toFixed(2); // Round to 2 decimal places

    return isNaN(roundedPercentage) ? 0 : roundedPercentage;
  };

  const handleEditClick = (item) => {
    setSelectedItem(item)
    setIsModelOpen(true)
  }

  const downloadExcel = () => {
    if (filteredData.length === 0) {
      alert("No data available to download.");
      return;
    }


    // Prepare data for Excel
    const excelData = filteredData.map((item, index) => ({
      "#": activePag.current * sort + index + 1,
      "Part No.": item?.masterItem?.partNo || "N/A",
      "Description": item?.masterItem?.description || "N/A",
      "Authorized": item?.qtyAuth || 0,
      "unit": item?.masterItem?.unit?.name || "N/A",
      "Received": item?.totalRecive || 0,
      "Transferred": item?.transfer || 0,
      "MIV": item?.totalMiv || 0,
      "Critical Status":
        item?.currentStock <= item?.criticalStockQty
          ? `${item?.criticalStockQty} | Low`
          : item?.criticalStockQty || 0,
      "Current Stock": item?.currentStock || 0,
      "Damage": item?.damage || 0,
      "%": `${Persentage(item)}%`,
    }));

    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `Inventory.xlsx`);
  };

  function handlepercentage() {

  }

  const handleCriticalToggle = async (item) => {
    try {
      const updatedValue = !item.critical;
      await ProductServices.UpdateInventory(item._id, { critical: updatedValue });
      setRun((prev) => prev + 1);
    } catch (error) {
      console.error("Error updating inventory:", error);
    }
  };

  return (
    <>
      <UpdateInventory
        item={selectedItem}
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        {loading ? (
          <Loader />
        ) : (

          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">

                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Search Inventory</label>
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          id="searchInput"
                          placeholder="Search by Part No.or Description"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Select Store</label>
                        <select
                          className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                          value={selectedStore}
                          onChange={handleStoreChange}
                        >
                          {stores.map((store) => (
                            <option key={store._id} value={store._id}>
                              {`${store.name}, ${store.location}`}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Select Display Rows</label>
                        <Select

                          placeholder="Select Display Rows"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>Critical Inventory List<span className="badge bg-orange ms-2">{filteredData.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        {user.data.user.role === 'superAdmin' && (
                          <div className="d-flex justify-content-end me-3 mb-2">

                            <Button
                              variant="success"
                              size="sm"
                              onClick={downloadExcel}
                              className="p-2"
                            >
                              <i className="fas fa-file-excel me-1"></i>
                              Download Excel
                            </Button>
                          </div>

                        )}


                        <div className="scrolltable">
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead className="sticky-table-header">
                              <tr>
                                <th>#</th>
                                <th>Part No.</th>
                                <th>Image</th>
                                <th>Description</th>
                                <th>Unit</th>
                                <th>Authorized</th>
                                <th>Received</th>
                                <th>Transfered</th>
                                <th>MIV</th>
                                <th>Critical
                                  <br /> Status</th>
                                <th>Current
                                  <br />Stock</th>
                                <th>Damage</th>
                                <th>%</th>
                                <th>Critical</th>
                                {user.data.user.role === 'superAdmin' && (
                                  <th>Action</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                                currentData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{activePag * sort + index + 1}</td>
                                    <td>{item?.masterItem?.partNo}</td>
                                    <td>
                                      {item?.masterItem?.image ? (
                                        <img
                                          src={`https://indigoinfra.in/img/product/${item?.masterItem?.image}`}
                                          alt={item?.masterItem?.partNo}
                                          className="thumbnail-image"
                                        />
                                      ) : (
                                        "No image"
                                      )}
                                    </td>
                                    <td className="scrollable-description">{item?.masterItem?.description}</td>
                                    <td>{item?.masterItem?.unit?.name}</td>

                                    <td>{item?.qtyAuth}</td>

                                    <td>{Number.isInteger(item?.totalRecive) ? item?.totalRecive : item?.totalRecive.toFixed(2)}</td>

                                    <td>{item?.transfer}</td>
                                    <td>{item?.totalMiv}</td>
                                    <td className="scrollable-description">{item?.currentStock <= item?.criticalStockQty ? `${item?.criticalStockQty} | Low` : item?.criticalStockQty}</td>
                                    <td>{Number.isInteger(item?.currentStock) ? item?.currentStock : item?.currentStock.toFixed(2)}</td>
                                    <td>{item?.damage || 0}</td>
                                    <td>{Persentage(item)}%</td>
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        checked={item.critical === true}
                                        onChange={() => handleCriticalToggle(item)}
                                      />
                                    </td>

                                    {user.data.user.role === 'superAdmin' && (

                                      <td>
                                        <button
                                          className="btn btn-primary btn-xs sharp"
                                          onClick={() => handleEditClick(item)} // Open modal on edit click
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="14">No data available</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing{" "}
                            {filteredData.length === 0 ? 0 : activePag * sort + 1}{" "}
                            to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePag + 1) * sort
                            )}{" "}
                            of {filteredData.length} entries
                          </div>
                          <Pagination
                            activePage={activePag}
                            totalPages={pagination}
                            onPageChange={onClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InventoryCriticalList;
